// Shared sort helpers for invoice-style tables.
// Natural numeric comparison so "INV-2" < "INV-10", with null/empty always last.

export function naturalCompare(a, b) {
  const tok = (v) => {
    const out = [];
    String(v ?? '').toLowerCase().replace(/(\d+)|(\D+)/g, (_, n, s) => {
      out.push(n != null ? [parseInt(n, 10), ''] : [Number.POSITIVE_INFINITY, s]);
      return '';
    });
    return out;
  };
  const ax = tok(a), bx = tok(b);
  for (let i = 0; i < Math.max(ax.length, bx.length); i++) {
    const an = ax[i], bn = bx[i];
    if (!an) return -1;
    if (!bn) return 1;
    if (an[0] !== bn[0]) return an[0] - bn[0];
    const sc = an[1].localeCompare(bn[1]);
    if (sc) return sc;
  }
  return 0;
}

const DATE_FIELDS = new Set(['issue_date', 'due_date', 'created_at', 'end_date', 'start_date']);
const NUM_FIELDS = new Set(['total', 'balance', 'amount', 'subtotal', 'balance_due']);

// Compare two records by a field. Empty/null values sort last in BOTH directions.
export function compareInvoices(a, b, field, order = 'asc') {
  const dir = order === 'desc' ? -1 : 1;
  const va = a ? a[field] : undefined;
  const vb = b ? b[field] : undefined;
  const na = va == null || va === '';
  const nb = vb == null || vb === '';
  if (na && nb) return 0;
  if (na) return 1;   // nulls always last
  if (nb) return -1;

  let r;
  if (field === 'invoice_number') r = naturalCompare(va, vb);
  else if (DATE_FIELDS.has(field)) {
    const ta = new Date(va).getTime(), tb = new Date(vb).getTime();
    r = (isNaN(ta) ? 0 : ta) - (isNaN(tb) ? 0 : tb);
  } else if (NUM_FIELDS.has(field)) r = (Number(va) || 0) - (Number(vb) || 0);
  else r = String(va).localeCompare(String(vb));
  return r * dir;
}
